<template>
	<div id="logList" class="wp100">
		<el-table :data="tableData" stripe style="width: 100%"
			:header-cell-style="{background:'#ECECEF',color:'#909399'}">
			<!-- <el-table-column prop="log_title" width="80px" label="类型">
			</el-table-column> -->
			<el-table-column prop="content" label="沟通内容">
			</el-table-column>
			<el-table-column prop="add_time" width="160px" label="添加时间">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: []
			};
		},
		methods: {
			init(feedbackList) {
				this.tableData = feedbackList;
			},
		},
	};
</script>

<style>
</style>
